module.exports = __webpack_public_path__ + "static/media/autoDoor4.f1704794.png";